import { render, staticRenderFns } from "./IndicadorKmHr.vue?vue&type=template&id=0c316920&scoped=true"
import script from "./IndicadorKmHr.vue?vue&type=script&lang=js"
export * from "./IndicadorKmHr.vue?vue&type=script&lang=js"
import style0 from "./IndicadorKmHr.vue?vue&type=style&index=0&id=0c316920&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c316920",
  null
  
)

export default component.exports